export const VALIDATION_TYPE = {
  NUMBER: 'NUMBER',
  FLOAT: 'FLOAT',
  EMAIL: 'EMAIL',
  PHONE: 'PHONE',
  PHONE_WITH_HYPHEN: 'PHONE_WITH_HYPHEN',
  BIRTHDAY: 'BIRTHDAY',
  BIRTHDAY_WITH_HYPHEN: 'BIRTHDAY_WITH_HYPHEN',
  TIME_HHMM: 'TIME_HHMM',
  THOUSAND_COMMA: 'THOUSAND_COMMA',
  IP: 'IP',
};
